export default __webpack_public_path__ + "static/media/todd.f7cecc48.jpeg";